import { Phone, DollarSign, Rocket, Percent } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { WaitlistForm } from "./WaitlistForm";

export const PricingComparison = () => {
  const [showWaitlist, setShowWaitlist] = useState(false);

  return (
    <section className="py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary text-center mb-12">
          La différence est claire comme de l'eau de roche
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Sans NLocale */}
          <div className="p-4 sm:p-6 rounded-xl border-2 border-gray-200">
            <h3 className="text-xl sm:text-2xl font-bold text-primary mb-8">Sans NLocale</h3>
            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <Phone className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500 mt-1 flex-shrink-0" />
                <span className="text-base sm:text-lg">
                  "Bonjour, c'est pour une réservation..."
                </span>
              </li>
              <li className="flex items-start gap-4">
                <DollarSign className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500 mt-1 flex-shrink-0" />
                <span className="text-base sm:text-lg">20% de frais sur Booking</span>
              </li>
            </ul>
          </div>

          {/* Avec NLocale */}
          <div className="p-4 sm:p-6 rounded-xl border-2 border-secondary bg-secondary/5">
            <h3 className="text-xl sm:text-2xl font-bold text-secondary mb-8">Avec NLocale</h3>
            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <Rocket className="w-5 h-5 sm:w-6 sm:h-6 text-secondary mt-1 flex-shrink-0" />
                <span className="text-base sm:text-lg">
                  Calendrier qui bosse à votre place
                </span>
              </li>
              <li className="flex items-start gap-4">
                <Percent className="w-5 h-5 sm:w-6 sm:h-6 text-secondary mt-1 flex-shrink-0" />
                <span className="text-base sm:text-lg">0% de commission. Si, si.</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-12">
          <Button
            size="lg"
            className="bg-secondary hover:bg-secondary/90 text-white px-4 sm:px-8 py-4 sm:py-6 text-sm sm:text-lg rounded-full transition-all duration-300 hover:scale-105 w-full sm:w-auto"
            onClick={() => setShowWaitlist(true)}
          >
            Je veux ces 0% de commission 🎯
          </Button>
        </div>
      </div>

      <WaitlistForm
        isPro={true}
        open={showWaitlist}
        onOpenChange={setShowWaitlist}
      />
    </section>
  );
};